import {throttle} from "../../../utils/decorators/throttle";
import {MEDIA} from "../../constants";

export const initWindow = () => {
	const MS = 500;

	const hash = location.hash;
	
	if (hash && window.innerWidth >= MEDIA.DESKTOP)
	{
		const slide = document.querySelector(`${hash}`);
		
		if (slide)
		{
			throttle(window.scrollTo(0, slide.offsetTop), MS);
		}
	}
};
